import { render, staticRenderFns } from "./areaselect.vue?vue&type=template&id=0707f829&"
import script from "./areaselect.vue?vue&type=script&lang=js&"
export * from "./areaselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports